import React, { useEffect, useState } from 'react'
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';
import Grid from '@mui/material/Unstable_Grid2';
import { SelectChangeEvent } from '@mui/material/Select';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useAppSelector } from '../../hooks'
import { selectBreakPoints } from '../../Slices/appSlicer';

const Chart = () => {
    const theme = useTheme()
    const [chartWidth, setChartWidth] = useState<number>(400)
    const [chartHeight, setChartHeight] = useState<number>(210)
    const breakpoints = useAppSelector(selectBreakPoints)
    const isSm = useMediaQuery(theme.breakpoints.down('sm'))

    const calcWidth = () => {

        if (breakpoints.iphonePotrait) {
            setChartWidth(300)
        } else if (breakpoints.iphoneLandScape) {
            setChartWidth(330)
            setChartHeight(190)
        } else if (breakpoints.ipadPotrait) {
            setChartWidth(480)
            setChartHeight(190)
        } else if (breakpoints.ipadLandScape) {
            setChartWidth(440)
            setChartHeight(190)
        } else if (isSm) {
            setChartWidth(300)
        }
    }
    useEffect(() => {
        calcWidth()
    }, [breakpoints.ipadLandScape, breakpoints.ipadPotrait, breakpoints.iphoneLandScape, breakpoints.iphonePotrait])

    return (
        // <Grid container spacing={2}>
        <Grid sm={12}>

            <LineChart
                width={chartWidth}
                height={chartHeight}
                data={data}
                margin={{
                    top: 10,
                    right: 30,
                    left: 20,
                    bottom: 5,
                }}
            >
                <CartesianGrid strokeDasharray="0 1" />
                <XAxis dataKey="name" />
                <YAxis dataKey={"day"} />
                <Tooltip />
                <Line type="monotone" dataKey="day" stroke="#E7F011" activeDot={{ r: 8 }} />
            </LineChart>
        </Grid>
        // </Grid>
    )
}
const data = [
    {
        name: 'Mon',
        day: 5,
    },
    {
        name: 'Tue',
        day: 7,
    },
    {
        name: 'Wed',
        day: 8,
    },
    {
        name: 'Thu',
        day: 4,
    },
    {
        name: 'Fri',
        day: 3,
    },
    {
        name: 'Sat',
        day: 5,
    },
    {
        name: 'Sun',
        day: 4,
    },
];
export default Chart